module.exports = __webpack_public_path__ + "img/ic_users_inactive.c80f9096.png";